import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-card-qr-code-generator",
  templateUrl: "./card-qr-code-generator.component.html",
})
export class CardQrCodeGeneratorComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
